import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { EnedisConsentService, EnedisConsent } from '../enedis-consent.service';

import { parseJwt } from 'src/app/shared/all.helpers';
import { EnedisAccessRightStatus } from '../../../enedis.models';

@Component({
    selector: 'app-enedis-consent-revoked',
    templateUrl: './enedis-consent-revoked.component.html',
    styleUrls: ['./enedis-consent-revoked.component.scss'],
})
export class EnedisConsentRevokedComponent {
    token: string | null = null;
    error: boolean = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private enedisConsentService: EnedisConsentService,
    ) {}

    async ngOnInit(): Promise<void> {
        this.activatedRoute.queryParams.subscribe(async (params) => {
            this.token = params['token'];

            if (!this.token) {
                this.error = true;
                console.error('Token is missing');
                return;
            }

            try {
                await this.enedisConsentService.updateConsent(
                    this.token,
                    EnedisAccessRightStatus.REVOKED,
                );
            } catch (err: any) {
                console.error('Error revoking consent', err);
                this.error = true;
            }
        });
    }
}
